import React, { useEffect } from 'react'

const HubspotContactForm = ({ portalId, formId }) => {
  useEffect(() => {
    // Check if script already exists
    if (!document.querySelector('script#hbspt-form')) {
      const formScript = document.createElement('script')
      formScript.src = 'https://js.hsforms.net/forms/v2.js'
      formScript.id = 'hbspt-form'
      formScript.async = true

      formScript.onload = () => {
        if (window.hbspt) {
          window.hbspt.forms.create({
            portalId,
            formId,
            target: '#react-hubspot-form',
          })
        }
      }

      document.body.appendChild(formScript)
    } else {
      // If script already exists and window.hbspt is available, load the form immediately
      if (window.hbspt) {
        window.hbspt.forms.create({
          portalId,
          formId,
          target: '#react-hubspot-form',
        })
      }
    }
  }, [portalId, formId])

  return (
    <div>
      <div id="react-hubspot-form"></div>
    </div>
  )
}

export default HubspotContactForm
